export const MONTH_FIELD_WIDTH = '35px';
export const YEAR_FIELD_WITH = '60px';
